import utilFunctions from "@/utils/functions.js";

export default {
  permissions: {},
  getPermissionsFromLocalStorage() {
    let userData = utilFunctions.getUserDetailsLocalStorage();
    if (userData) {
      this.permissions = userData.permissions;
    }
    return this.permissions;
  },
  setPermissions(userData) {
    if (userData) {
      localStorage.setItem("user_data", JSON.stringify(userData));
      this.permissions = userData.permissions;
    }
  },
  getPermission(key, subKey) {
    if (!this.permissions || Object.keys(this.permissions).length == 0) {
      this.getPermissionsFromLocalStorage();
    }
    if (subKey) {
      return this.permissions[key][subKey];
    } else {
      return this.permissions[key];
    }
  },
};
